import { Outlet } from "react-router-dom"
import { cn } from "~/common/cn"
import { LoggedInFooter } from "~/footers/logged-in-footer"
import LoggedInHeader from "~/headers/logged-in-header"

export const SandwichPageLayout: React.FC<{ full: boolean }> = ({ full }) => (
  <div className="flex min-h-screen flex-col break-words">
    <LoggedInHeader />

    <main className="flex-1 overflow-y-auto p-4">
      <div className={cn("mx-auto w-full md:px-4", { "max-w-7xl": !full })}>
        <Outlet />
      </div>
    </main>

    <LoggedInFooter />
  </div>
)
